<template>
  <button 
    v-on:click="$parent.$emit('submitForm')" 
    class="form__newsletter__btn" aria-label="Submit button" type="submit">
    <svg xmlns="http://www.w3.org/2000/svg" class="form__newsletter__btn__svg accent-color" viewBox="0 0 20 20" stroke="#000">
      <path d="M0 10h17.5" vector-effect="non-scaling-stroke"/>
      <path d="M9.5 2l8 8-8 8" fill="none" vector-effect="non-scaling-stroke"/>
    </svg>
  </button>
</template>
  
<script>
import icon from '../icons/icon.vue';

export default {
  props: {},
  components: {
    icon
  }
}
</script>